import React from "react";
import { toast } from "react-toastify";
import { Modal, Button, Alert } from "@/Components/Common/Tailwind";
import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { API, BACKEND_HOST } from "../../api";
import { getAccessToken } from "../../api/auth";
import { packageService } from "../../api/services/package.service";

type ReservationOption = {
  name: string;
};

type ReservationInfo = {
  id: string | number;
  reserv_id: string | number;
  name: string;
  reservationDate: string;
  reservationEndDate?: string;
  spot: string;
  reserv_state: string;
  options?: ReservationOption[];
  depositRequired?: boolean;
};

type ReservationQrResponse = {
  qr_code: string;
  reservation_id: number;
  checkin_date?: string;
  is_valid: boolean;
};

interface ReservationGiftUseModalProps {
  setVisible: (value: boolean) => void;
  visible: boolean;
  info: ReservationInfo;
  setInfo: (value: Partial<ReservationInfo>) => void;
  needRefresh: () => void;
}

const ReservationGiftUseModal: React.FC<ReservationGiftUseModalProps> = ({
  setVisible,
  visible,
  info,
  setInfo,
  needRefresh,
}) => {
  const [checkModal, setCheckModal] = React.useState<boolean>(false);
  const [checkQrCode, setCheckQrCode] = React.useState<string>("");

  const togModal = () => {
    setVisible(!visible);
    setCheckQrCode("");
  };

  const togCheckModal = () => {
    setCheckModal(!checkModal);
  };

  return (
    <React.Fragment>
      <Modal toggle={togModal} isOpen={visible} centered>
        <div>
          {/* qr코드 받아올 시에 그려야함 */}
          {!info.depositRequired ? (
            <div className="mb-4 flex justify-center">
              {checkQrCode ? (
                <QRCodeSVG value={checkQrCode} />
              ) : (
                <Button
                  onClick={() => {
                    packageService.getReservationQRCode(Number(info.reserv_id)).then((obj: ReservationQrResponse) => {
                      console.log(obj);
                      setCheckQrCode(obj.qr_code);
                    });
                  }}
                  variant="primary"
                >
                  QR 생성하기
                </Button>
              )}
            </div>
          ) : null}
          <ul className="list-group">
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">예약ID :</span>
              <span>{info.reserv_id}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">예약상품 :</span>
              <span>{info.name}</span>
            </li>

            {info.reservationEndDate && info.reservationDate === info.reservationEndDate ?
              <li className="list-group-item">
                <span className="font-semibold w-24 inline-block">예약일 :</span>
                <span>{info.reservationDate}</span>
              </li> :
              <li className="list-group-item">
                <span className="font-semibold w-24 inline-block">예약일 :</span>
                <span>{info.reservationDate} ~ {info.reservationEndDate}</span>
              </li>}

            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">자리 :</span>
              <span>{info.spot}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">상태 :</span>
              <span>{info.reserv_state}</span>
            </li>
            {info.options && info.options.length ? (
              <li className="list-group-item">
                <span className="font-semibold w-24 inline-block">옵션: </span>
                {info.options.map((item, idx, obj) => {
                  return (
                    <span key={idx}>
                      {item.name}
                      {idx !== obj.length - 1 ? ", " : ""}
                    </span>
                  );
                })}
              </li>
            ) : null}
          </ul>
          {info.depositRequired ? (
            <div className="mt-4 text-center">
              <p className="font-medium mb-2">체크인 하기전에 청소보증금을 결제해 주세요</p>
              <p className="text-sm leading-relaxed text-gray-600">
                <i className="ri ri-information-line align-middle text-lg mr-1"></i>&nbsp; 청소보증금이란?
                <br />
                청결한 시설 관리 및 비품 관리를 위해 패키지 상품 구매 시 청소보증금이 결제됩니다.
                <br />
                시설 이용 후 정리를 완료하고 체크아웃 버튼을 누르면 관리자가 정리 사항을 확인합니다.
                <br />
                <span className="text-red-500 font-medium">체크아웃 요청이 승인 되면 자동 환불됩니다.</span>
              </p>
            </div>
          ) : null}
        </div>
        <div className="flex justify-center gap-2 mt-4">
          <Button
            variant="secondary"
            onClick={() => {
              setInfo({});
              setVisible(!visible);
              setCheckQrCode("");
            }}
          >
            닫기
          </Button>
          {info.depositRequired ? (
            <Button
              onClick={() => {
                window.location.href = `/add-options-order?id=${info.reserv_id}&deposit=true`;
              }}
              variant="primary"
            >
              청소보증금 결제
            </Button>
          ) : (
            <Button
              onClick={() => {
                const confirmReserv = window.confirm("정말 사용하시겠습니까?");
                if (confirmReserv) {
                  packageService.useReservationGift(Number(info.id)).then((obj) => {
                    toast.success("예약 상태가 변경되었습니다!");
                    setVisible(!visible);
                    // alert("예약 상태가 변경되었습니다! " + JSON.stringify(obj))
                    needRefresh();
                  });
                }
              }}
              variant="primary"
            >
              체크인
            </Button>
          )}
        </div>
      </Modal>
      {/* <Modal toggle={togCheckModal} isOpen={checkModal} centered>
        <div className="my-4 mx-2">
          <h5 className="modal-title mb-3" id="staticBackdropLabel">
            예약상품 사용
          </h5>
          <p className="text-muted mb-4">정말 사용하시겠습니까</p>
          <p className="text mb-4">체크아웃 요청을 하지 않으면 청소보증금 환불이 불가할 수 있습니다.</p>
          <div className="flex flex-row items-center gap-2 justify-content-around">
            <Link
              to="#"
              className="legacy-btn btn-link link-success fw-medium"
              onClick={() => {
                setCheckModal(false);
              }}
            >
              <i className="ri-close-line me-1 align-middle"></i> 사용안함{" "}
            </Link>
            <Link
              to="#"
              className="legacy-btn btn-success"
              onClick={() => {
                setCheckModal(false);
                changeReserv().then((obj) => {
                  needRefresh();
                });
              }}
            >
              <i className="ri-check-line me-1 align-middle "></i>체크인
            </Link>
          </div>
        </div>
      </Modal> */}
    </React.Fragment>
  );
};
export default ReservationGiftUseModal;
